import './App.css';
import { Routes, Route } from 'react-router-dom';
import Cart from './containers/Cart/index';
import HomePage from './containers/HomePage/index';






function App() {
  return (
    <Routes>
      <Route exact path='/' element={<HomePage/>}/>
      <Route path='/a' element={<HomePage/>}/>
    </Routes>

  );
}

export default App;
